import { useEffect, useState } from 'react';
import matter from 'gray-matter';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

function BlogPost({ slug }) {
  const [post, setPost] = useState({ content: "", data: {} });

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/blog/${slug}.md`)
      .then(res => {
        if (!res.ok) {
          throw new Error(`Failed to fetch post: ${res.status}`);
        }
        return res.text();
      })
      .then(text => {
        const { content, data } = matter(text);
        setPost({ content, data });
      })
      .catch(err => {
        console.error(err);
        setPost({ content: "Error loading post.", data: {} });
      });
  }, [slug]);

  return (
    <div className="blog-post">
      {/* You can use post.data for title, date, etc., if needed */}
      <h1>{post.data.title}</h1>
      <ReactMarkdown rehypePlugins={[rehypeRaw]}>
        {post.content}
      </ReactMarkdown>
    </div>
  );
}


export default BlogPost;